import React from "react";
import { motion } from "framer-motion";
import { Network, Radio, ShieldCheck, Settings2, Sparkles } from "lucide-react";
import { SECTION } from "@/constants/testIds";
import { useI18n } from "@/i18n/I18nContext";

const ICONS = [Network, Radio, ShieldCheck, Settings2, Sparkles];

export default function Expertises() {
  const { t } = useI18n();
  const e = t.expertises;

  return (
    <section
      id="expertises"
      data-testid={SECTION.expertises}
      className="section-y bg-slate-50/70 relative"
    >
      <div className="container-x">
        <div className="max-w-3xl">
          <span className="text-overline">{e.overline}</span>
          <h2 className="mt-4 font-display font-semibold text-navy text-3xl sm:text-4xl lg:text-5xl leading-[1.1]">
            {e.title}
          </h2>
          <p className="mt-5 text-slate-600 leading-relaxed">{e.paragraph}</p>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {e.blocks.map((b, i) => {
            const Icon = ICONS[i] || Sparkles;
            return (
              <motion.article
                key={b.title}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.2 }}
                transition={{ duration: 0.5, delay: i * 0.07 }}
                data-testid={`expertise-card-${i}`}
                className={`group relative p-8 rounded-2xl border border-slate-200 bg-white overflow-hidden ${
                  i === 0 ? "lg:col-span-2" : ""
                }`}
              >
                <div className="absolute -top-16 -right-16 h-44 w-44 rounded-full bg-cyan-50 opacity-0 group-hover:opacity-70 transition-opacity duration-500" />
                <div className="relative">
                  <div className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-navy text-cyan-tech">
                    <Icon className="h-6 w-6" />
                  </div>
                  <h3 className="mt-6 font-display text-xl lg:text-2xl font-semibold text-navy">
                    {b.title}
                  </h3>
                  <ul className="mt-5 grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-2 text-sm text-slate-700">
                    {b.items.map((it) => (
                      <li key={it} className="flex items-start gap-2">
                        <span className="mt-1.5 inline-block h-1.5 w-1.5 rounded-full bg-gold flex-shrink-0" />
                        <span>{it}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </motion.article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
